import { ReduxActions } from '@src/redux/actions/interfaces/action.interface';
import { RecruiterActions } from '@src/redux/actions/recruiter/recruiter.enum';
import { SessionQuery } from '@src/graphql/generated';

export function recruiter(
  state: SessionQuery['currentRecruiter'] | null = null,
  action: ReduxActions,
): SessionQuery['currentRecruiter'] | null {
  switch (action.type) {
    case RecruiterActions.RECRUITER_SET:
      return action.payload;
    default:
      return state;
  }
}
